import {
  TeaserEntry,
} from "../helper/interfaces";
import React from "react";
import { AdInformationInterface } from "../helper/PageInformationInterface";
import { ContentType } from "../helper/enums";
import TeaserAudioMinimizedNN from "./teaserAudioMinimizedNN";
import TeaserMinimizedNN from "./teaserMinimizedNN";
import TeaserVideoMinimizedNN from "./teaserVideoMinimizedNN";
import TeaserAd from "./TeaserAd";
import TeaserFreeHtml from "./TeaserFreeHtml";
import TeaserCollectiveBox from "./TeaserCollectiveBox";
import TeaserCatchline from "./TeaserCatchline";
import TeaserKickerLiveTicker from "./TeaserKickerLiveTicker";
import TeaserKickerMatchday from "./TeaserKickerMatchday";
import TeaserInfoBox from "./TeaserInfoBox";
export interface TeaserData {
  teaser: TeaserEntry;
  className?: string;
  navigate?: (articleId: string, ressortId: string) => void;
  adInformation?: AdInformationInterface;
  ignoreLead?: boolean;
  isImportantTeaser?: boolean
  showImage?: boolean
  showResorts?: boolean
  isAlreadyLinked?: boolean
}

function TeaserMinimizedContainerNN(data: TeaserData) {
  const teaser = data.teaser;
  const isVideoOrPodcast = teaser.type == ContentType.Video || teaser.type == ContentType.GlomexVideo || teaser.type == ContentType.DailyMotionVideo || teaser.type == ContentType.Podcast;
  const isVideo = teaser.type == ContentType.Video || teaser.type == ContentType.GlomexVideo || teaser.type == ContentType.DailyMotionVideo;
  const isAd = teaser.type == ContentType.Advert
  const isFreeHTML = teaser.type == ContentType.FreeHtml
  const isCollectiveBox =  teaser.type == ContentType.CollectiveBox
  const isCatchline =  teaser.type == ContentType.Catchline
  const isKicker = teaser.type == ContentType.KickerMatchday || teaser.type == ContentType.KickerLiveTicker
  const isInfoBox = teaser.type == ContentType.InfoBox || teaser.type == ContentType.InfoBoxTeaser
  return (
    <>
      {!isVideoOrPodcast && !isAd && !isFreeHTML && !isCollectiveBox && !isCatchline && !isKicker && !isInfoBox &&
        <TeaserMinimizedNN teaser={teaser} adInformation={data.adInformation} navigate={data.navigate} showImage={data.showImage} showResorts={data.showResorts}  isAlreadyLinked={data.isAlreadyLinked} />
      }
      {isAd &&
        <TeaserAd teaser={data.teaser} adInformation={data.adInformation} />
      }
      {teaser.type == ContentType.Podcast &&
        <TeaserAudioMinimizedNN teaser={teaser} showImage={true} showResorts={true}  isAlreadyLinked={true} />
      }
      {isVideo &&
        <TeaserVideoMinimizedNN teaser={teaser} showImage={true} showResorts={true}  isAlreadyLinked={true} />
      }
      {isFreeHTML &&
        <TeaserFreeHtml teaser={data.teaser} adInformation={data.adInformation} />
      }
      {isCollectiveBox &&
        <TeaserCollectiveBox teaser={data.teaser} adInformation={data.adInformation} />
      }
      {isCatchline &&
        <TeaserCatchline teaser={data.teaser} adInformation={data.adInformation} navigate={data.navigate} />
      }
      {teaser.type == ContentType.KickerMatchday &&
        <TeaserKickerMatchday teaser={data.teaser} />
      }
      {teaser.type == ContentType.KickerLiveTicker &&
        <TeaserKickerLiveTicker teaser={data.teaser} />
      }
      {isInfoBox &&
        <TeaserInfoBox teaser={data.teaser} />
      }
    </>
  );
}

export default TeaserMinimizedContainerNN;
